import { useState } from 'react'
import { Table, Button, Modal, message, Tag, Flex } from 'antd'
import TableActions from '../../components/elements/TableActions'
import { usePermissions } from '../../hooks/usePermissions'
import { PermissionForm } from './components/PermissionForm'
import { ADMIN, PERMISSIONLABELS, PERMISSIONS, ROLEKEYS } from '../../utils/Permissions.const'

export default function Permissions() {
  const [isActionLoading, setIsActionLoading] = useState('')
  const [isFormModalOpen, setFormModal] = useState(false)
  const [formValues, setFormValues] = useState({})

  const { data = [], isLoading, createPermission, deletePermission, updatePermission } = usePermissions()

  const onFormModalClose = () => {
    setFormValues()
    setFormModal(false)
  }

  const onFormModalOpen = (values) => {
    if (values) setFormValues({ ...values, email: values.user?.email })
    setFormModal(true)
  }

  const onSubmit = async (values) => {
    try {
      const { email, ...payload } = values
      setIsActionLoading(true)

      const action = formValues?._id ? updatePermission : createPermission

      await action(payload)
      onFormModalClose()
    } catch (error) {
      message.error(error.message)
    } finally {
      setIsActionLoading(false)
    }
  }

  const onDeletePermission = async ({ _id, user }) => {
    try {
      Modal.confirm({
        title: 'מחיקה',
        content: `האם למחוק את ההרשאה של "${user.email}"?`,
        okText: 'אישור',
        async onOk() {
          await deletePermission(_id)
        },
      })
    } catch (error) {
      message.error(error.message)
    } finally {
    }
  }

  return (
    <div>
      <Table
        dataSource={data}
        loading={isLoading || isActionLoading}
        rowKey="_id"
        bordered
        pagination={{
          pageSize: 10,
          pageSizeOptions: [10],
        }}
        columns={[
          {
            title: 'מייל להרשאה',
            width: 200,
            dataIndex: 'user',
            render: (user) => <Tag key={user.email}>{user.email}</Tag>,
          },
          {
            title: 'סטטוס',
            dataIndex: 'role',
            render: (role) => <Tag key={role}>{role === ROLEKEYS.ADMIN ? ADMIN : PERMISSIONS}</Tag>,
          },
          {
            title: 'פיצ׳רים',
            dataIndex: 'permissions',
            render: (permissions) =>
              permissions?.map((permission) => <Tag key={permission}>{PERMISSIONLABELS[permission]}</Tag>),
          },
          {
            width: 80,
            render: (record) => {
              return (
                <TableActions
                  onDeleteClick={() => onDeletePermission(record)}
                  onUpdateClick={() => onFormModalOpen(record)}
                />
              )
            },
          },
        ]}
        title={() => (
          <Flex justify="flex-end">
            <Flex>
              <Button type="primary" onClick={() => onFormModalOpen()}>
                {'יצירת הרשאה'}
              </Button>
              <Modal title={' '} open={isFormModalOpen} footer={null} destroyOnClose onCancel={onFormModalClose}>
                <PermissionForm onSubmit={onSubmit} initialValues={formValues} isLoading={isLoading} />
              </Modal>
            </Flex>
          </Flex>
        )}
      />
    </div>
  )
}
